import React, { Component } from 'react'
import { Row, Col, Image,Table } from 'antd'
import {prUrl} from '../config.js'
import '../../App.css'

const infoBoxCcolumns = [
    {
      title: '属性项',
      dataIndex: 'label',
      key: 'label',
      width: '30%', 
      align: 'center',    
    },
    {
      title: '属性值',
      dataIndex: 'value',
      key: 'value',
    },
]

export default class PlaneTypeInfoBox extends Component {
    render(){
        const wikipedia = this.props.wiki.wikipedia
        if (this.props.infobox && this.props.infobox.length > 1){
            return(
                <div className="plane-type-infobox">
                    <Row align='middle' justify='center'>
                        <Col span={12} >
                            <Image src={prUrl+wikipedia[0].encryptedImageUrl} width={'30vw'}></Image>
                        </Col>    
                        <Col span={12} >
                            <h3 align='center'><a href={prUrl+wikipedia[0].encryptedUrl} target="blank">{this.props.label}</a></h3>
                            <Table columns={infoBoxCcolumns} showHeader={false} dataSource={this.props.infobox} size="small" pagination={{hideOnSinglePage:true}}></Table>
                        </Col>                
                    </Row>                    
                </div>
            )
        }
    }
}